import Container from "../layout/Container";
import BuylistingCustomShipping from "./BuylistingCustomShipping";

const Offer = () => {
  return (
    <Container>
      <div className="rounded border border-solid border-darkGreen border-opacity-30 py-5 px-4">
        <div>
          <div className="flex justify-end">
            <div className="flex flex-col justify-center">
              <p className="w-[151px] rounded-md bg-quantityColor py-1 px-8 font-pop text-sm font-semibold text-secondary">
                <span>0</span> Watching
              </p>
              <p className="mt-1 flex justify-center font-pop text-xs font-semibold">
                + Add to watchlist
              </p>
            </div>
          </div>
          <div className="mt-5 flex items-center gap-x-[215px]">
            <p className="mb-1 font-pop text-xs font-semibold text-darkGreen">
              Price
            </p>
            <p className="mb-1 font-pop text-xs font-semibold text-darkGreen">
              Estimate market value
            </p>
          </div>
          <div>
            <div className="flex items-center gap-x-16">
              <p className="font-regular w-[183px] border border-solid border-[#A3B4B6] py-2.5 px-2.5 font-inter text-base text-primary">
                R599,999
              </p>
              <p className="font-regular w-[183px] border border-solid border-[#A3B4B6] py-2.5 px-2.5 font-inter text-base text-primary">
                R599,999
              </p>
            </div>
            <div className="flex items-center justify-between">
              <button className="mt-6 rounded-md bg-primary py-3 px-[76px] font-pop text-xs font-bold text-white">
                Buy now
              </button>
              <button className="mt-6 rounded-md bg-primary py-3 px-[108px] font-pop text-xs font-bold text-white">
                Make an offer
              </button>
            </div>
          </div>
        </div>
        <BuylistingCustomShipping />
      </div>
    </Container>
  );
};

export default Offer;
